import { useState, useEffect } from "react";
import { handleSubmitPromise } from "../../utils/handleSubmitPromise";
import { DefaultFooter, LoadingBox, SmartForm } from "./SmartForm";
import { ErrorMessage, SuccessMessage } from "../static/Messages";

export const ConfirmForm = ({ children, onClose, onSubmit, modalState, buttonText, buttonIcon, buttonStyle = 'primary' }) => {
    const [err, setErr] = useState("");
    const [loading, setLoading] = useState(false)
    const [success, setSuccess] = useState(false)

    useEffect(() => {
        if(modalState) {
            setErr("");setLoading(false);setSuccess(false);
        }
    }, [modalState])

    const formSubmit = () => {
        handleSubmitPromise(onSubmit(), setErr, setSuccess, setLoading)
    }

    return(
        <SmartForm onSubmit={formSubmit} states={[loading, err, success]}>
            {children}
            <ErrorMessage err={err}/>
            <SuccessMessage onHide={onClose} expand={false} success={success}>¡Guardado correctamente!</SuccessMessage>
            <LoadingBox expand={false}>
                <DefaultFooter cancelOnly={true} onClose={onClose}/>
                <button className={`uk-button uk-button-${buttonStyle}`} onClick={formSubmit}><i className={`fa ${buttonIcon}`}></i> <span className="hide-s">{buttonText}</span></button>
            </LoadingBox>                    
        </SmartForm>
    )
}
